
import Home from "components/FrontEnd/Home";
import HowItWorks from "components/FrontEnd/HowItWorks";
import AboutUs from "components/FrontEnd/AboutUs";
import Faq from "components/FrontEnd/Faq";
import FaqDirectors from "components/FrontEnd/FaqDirectors";
import FaqAdjudicators from "components/FrontEnd/FaqAdjudicators";
import commentGallery from "components/FrontEnd/commentGallery";
import PrivacyContact from "components/FrontEnd/PrivacyContact";
import Dashboard from "components/FrontEnd/Dashboard";
import ContactUs from "components/FrontEnd/ContactUs";
import CustomerTestimonials from "../components/FrontEnd/Testimonials/CustomerTestimonials";

const FrontEndRoutes = [

  {
    path          : "/Home",
    name          : "Home",
    component     : Home,
    showMenu      : true,
    number        : 1
  },
  {
    path          : "/How_It_Works",
    name          : "How it works",
    component     : HowItWorks,
    showMenu      : true,
    number        : 2
  },
  {
    path          : "/Adjudicator_Comments",
    name          : "Music Director Login",
    component     : commentGallery,
    showMenu      : true,
    number        : 3
  },
  {
    path          : "/Dashboard",
    name          : "Dashboard",
    component     : Dashboard,
    showMenu      : true,
    number        : 4
  },
  {
    path          : "/About_Us",
    name          : "About Us",
    component     : AboutUs,
    showMenu      : true,
    number        : 5
  },
  {
    path          : "/contact_us",
    name          : "Contact Us",
    component     : ContactUs,
    showMenu      : true,
    number        : 5
  },
  {
    path          : "/privacycontact",
    name          : "Privacy Contact",
    component     : PrivacyContact,
    showMenu      : false,
    number        : 6
  },
  {
    path          : "/faq",
    name          : "FAQs",
    component     : Faq,
    showMenu      : false,
    number        : 7
  },
  {
    path          : "/faq_directors",
    name          : "FaqDirectors",
    component     : FaqDirectors,
    showMenu      : false,
    number        : 7
  },
  {
    path          : "/faq_adjudicators",
    name          : "FaqAdjudicators",
    component     : FaqAdjudicators,
    showMenu      : false,
    number        : 7
  },
  {
    path          : "/Customer_Testimonials",
    name          : "CustomerTestimonials",
    component     : CustomerTestimonials,
    showMenu      : false,
    number        : 7
  },
  {
    path          : "/",
    name          : "Home",
    component     : Home,
    showMenu      : false,
    number        : 0
  }
];

export default FrontEndRoutes;



// WEBPACK FOOTER //
// ./src/routes/FrontEndRoutes.jsx